/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Tasks/New/NewTaskOverlay/Content/Header"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="New task"
/>
</div>
<div
  data-testid="Header.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
{children}
</React.Fragment>)
}